module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newVersionAvailable":"New version available!","clickHereToRefresh":"Click here to refresh"},"th":{"newVersionAvailable":"เวอร์ชั่นใหม่มาแล้ว!","clickHereToRefresh":"กดเพื่อรีเฟรชได้เลย"}}')
  delete Component.options._Ctor
}
